import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { AppConfigService } from 'src/app/shared/service/app-config.service';
import { MatomoTracker } from 'ngx-matomo';
import { TranslateService } from '@ngx-translate/core';
import { JsMenu } from 'src/app/layout/models/layout-model';
import { AuthService } from 'src/app/shared/auth/auth.service';



@Injectable({
  providedIn: 'root',
})
export class DomainGuard implements CanActivate {

  constructor(private router: Router, private ConfigService: AppConfigService, private matomotracker: MatomoTracker, private translateService: TranslateService,
    private authServ: AuthService
  ) {
  }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean> {
    let authMenusStr = localStorage.getItem('AuthMenus');
    if (authMenusStr) {
      //如果已有權限菜單，則直接判斷，但要後台刷新確保下一次訪問能拿到最新的權限菜單
      this.authServ.handleMenus().subscribe();
    } else {
      //如果沒有權限菜單，則等待后端返回權限菜單後再重取判斷
      await this.authServ.handleMenus().toPromise();
      authMenusStr = localStorage.getItem('AuthMenus');
    }
    if (!authMenusStr) {
      this.router.navigate(['/pages/PageNotFoundComponent']);
    }

    const authMenus: JsMenu[] = JSON.parse(authMenusStr);

    if (!authMenus || authMenus.length === 0) {
      this.router.navigate(['/pages/PageNotFoundComponent']);
    }

    const currentUrl = route['_routerState']?.url || ''; // 例如: /pages/wmsm-pages/Source/sourcingrequest
    if (!this.isAllowed(authMenus, currentUrl)) {
      this.router.navigate(['/pages/PageNotFoundComponent']); // 如果用户没有权限，重定向到错误页面
    }

    this.matomotracker.trackPageView(route.routeConfig.component.name);
    this.matomotracker.trackEvent(route.routeConfig.component.name, "view", "Transation", 1);
    return true;
  }

  private isAllowed(authMenus: JsMenu[], checkUrl: string): boolean {
    for (const menu of authMenus) {
      if (menu.tCode && checkUrl.indexOf(menu.tCode) != -1) {
        return true;
      }
      if (menu.childMenus && menu.childMenus.length > 0) {
        if (this.isAllowed(menu.childMenus, checkUrl)) {
          return true;
        }
      }
    }
    return false;
  }
}